import * as angular from 'angular';
import ClickTrackerView from './ClickTrackerView.html';
import { clickTrackerMfeScriptSource } from 'app.constants';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { ClickTrackerController } from './ClickTrackerController';
import { ClickTrackerConstants } from './ClickTrackerConstants';
const stateBase = {
    views: {
        'content@auth.application.detail': {
            template: ClickTrackerView,
            controller: ClickTrackerController,
            controllerAs: '$ctrl',
        },
    },
    onEnter: () => {
        return MicroFrontendService.addSource(clickTrackerMfeScriptSource);
    },
};
export const clicktracker = angular
    .module('clicktracker', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(ClickTrackerConstants.CLICK_TRACKER_STATE, {
            url: '/clicktracker',
            ...stateBase,
        }).state(ClickTrackerConstants.ICEBREAKER_STATE, {
            url: '/icebreaker',
            ...stateBase,
        }).state(ClickTrackerConstants.CONVERSATION_SETTINGS_STATE, {
            url: '/conversation-settings',
            ...stateBase,
        }).state(ClickTrackerConstants.CONVERSATION_SETTINGS_CONNECTIONS_STATE, {
            url: '/conversation-settings/connections',
            ...stateBase,
        }).state(ClickTrackerConstants.CONVERSATION_SETTINGS_EVENTS_STATE, {
            url: '/conversation-settings/events',
            ...stateBase,
        });
    }])
    .name;
